import Fragment from './fragment.js'
import Card from './card.js'
import Form from './form.js'

export default {
    card: Card,
    form: Form,
    fragment: Fragment,
}
